import React,{useEffect} from 'react'
import { navigate } from 'gatsby'
import styled from 'styled-components'

import { LinkAnchor } from '../components/LinkAnchor'

import {
  Box,
  Button,
  Paragraph,
  P,
  H1,
  H2,
  H3,
  ButtonUnstyled,
  Card,
  Chip,
} from '@allied-solutions/affinity'
import { ArrowRight } from '@allied-solutions/affinity-react-icons/dist/standard'

import { formatDate } from '../functions'
import {
  usePageData,
  useRedirectToEnterRefId,
  useStore,
  useWindowWidth,
  useLogTransaction
} from '../hooks'
import { theme } from '../theme.js'
import { AppLayout, InfoBox } from './AppLayout'
import { ButtonGroup } from './ButtonGroup'
import { SubmitInsuranceLayout } from './SubmitInsuranceLayout'

const StyledCard = styled(Card)`
  border-radius: ${props => props.theme.radii.xl};
`

const ConfirmationAgent = ({ location, data }) => {
  const { dispatch, state } = useStore()
  useRedirectToEnterRefId()
  const { workflowType } = usePageData(location)
  const windowWidth = useWindowWidth()
  const mediumBreakpoint = Number(theme.breakpoints[1].replace('px', ''))
  const {LogTransaction } = useLogTransaction();
  
  useEffect(() => {
    Object.values(location.state).forEach(async (logEvent) => {
      if(logEvent?.Event)
      await LogTransaction({
        type: logEvent?.Event,
        files: logEvent?.files
      });
    })
  }, [location.state]);


  return (
    // utilizing 'main' here causes duplication of landmark use, SubmitInsuranceLayout utilzes main in the Helment
    <SubmitInsuranceLayout location={location}>
      {/* <main> */}
      <AppLayout
        leftSide={
          <>
            <Paragraph
              mb={6}
              typeStyle="labelLarge"
              textAlign="left"
              color="gray600"
            >
              Thank you!
            </Paragraph>
            <H1 className="h4" typeStyle="headlineLarge.black">
              We successfully received your information.
            </H1>
            <Paragraph
              typeStyle="bodyMedium"
              textAlign="left"
              color="gray600"
              mb={14}
            >
              {(() => {
                if (state?.form?.PolicyholderEmailAddress) {
                  let additionalText;
                  if (windowWidth < mediumBreakpoint) {
                    additionalText = 'You will receive an email if we need any additional information.';
                  } else {
                    additionalText = 'You may now close this window.';
                  }
                  return `A confirmation email will be delivered to ${state.form.PolicyholderEmailAddress}. ${additionalText}`;
                }
                return 'You will receive an email if we need any additional information.';
              })()}
            </Paragraph>
            <LinkAnchor
              id={`ArticleCard--whatHappensNext__StyledLink`}
              to="/support/#iSubmittedMyInformationWhatHappensNext"
              css={`
                display: block;
              `}
            >
              <StyledCard>
                <Card.Header>
                  <Chip label="Help" rounded variant="brand"/>
                </Card.Header>
                <Box>
                  <H2 typeStyle="titleMedium.bold" color="text.default" py={4}>
                    Learn what happens after you submit your insurance.
                  </H2>
                  <Button
                     ghost
                     id="ConfirmationAgent__Help__Button--learnMore"
                     iconPos="right" 
                     icon={ArrowRight}
                     ml={-4}>
                      Learn More
                    </Button>
                </Box>
              </StyledCard>
            </LinkAnchor>
          </>
        }
        rightSide={
            <InfoBox>
              {(state.borrower.ReferenceID ||
                workflowType === 'other' ||
                workflowType === 'noReferenceId') && (
                <>
                  <H3
                    typeStyle="titleSmall.bold"
                    textAlign="left"
                  >
                    Confirmation
                    <P
                      display={['block', 'block', 'block', 'inline-block']}
                      ml={[null, '3']}
                      typeStyle="caption"
                      textAlign="left"
                      color="hint"
                    >
                      submitted on {formatDate(state.borrower.Date)}
                    </P>
                  </H3>
                  {data}
                </>
              )}
            </InfoBox>
        }
        footerButtons={
          <ButtonGroup display="flex" justifyContent="flex-end">
            <ButtonUnstyled
              id="SubmitInsurance__Confirm__Button--close"
              color="text.secondary"
              typeStyle="buttonMedium"
              size="md"
              mr={['0', '4xl']}
              onClick={() => {
                dispatch({ type: 'resetForm' })
                navigate('/')
              }}
            >
              Close
            </ButtonUnstyled>
            {windowWidth < mediumBreakpoint ? null : (
              <Button
                rounded
                outlined
                id="SubmitInsurance__Confirm__Button--print"
                variant="gray"
                onClick={() => window.print()}
              >
                Print Confirmation
              </Button>
            )}
          </ButtonGroup>
        }
      />
      {/* </main> */}
    </SubmitInsuranceLayout>
  )
}

export { ConfirmationAgent }
